import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import Home from "./pages/Home";
import Ricostruzione from "./pages/Ricostruzione";
import Corsi from "./pages/Corsi";
import Tornei from "./pages/Tornei";
import IstruttoriDetail from "./pages/IstruttoriDetail";
import Medagliere from "./pages/Medagliere";
import ContattiDetail from "./pages/ContattiDetail";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import History from "./pages/History";
import ScrollToTop from "./utils/ScrollToTop";
import "./i18n";

import sfondo from "./assets/logo-trasparente.png";

const basePath = process.env.REACT_APP_BASE_PATH || "/";

function App() {
  return (
    <BrowserRouter basename={basePath}>
      <ScrollToTop />

      <div className="general-background">
        <Header />
        {/* Logo watermark */}
        {/* <div
          className="background-logo"
          style={{ backgroundImage: `url(${sfondo})` }}
        /> */}

        <main
          className="
      flex-grow
      bg-no-repeat
      bg-center
      bg-fixed
      bg-[length:80%_auto]
      md:bg-[length:500px_auto]
    "
          style={{
            backgroundImage: `url(${sfondo})`,
            backgroundPosition: "center 150px",
          }}
        >
          {/* Contenuto */}
          <div>
            <Routes>
              <Route path="/" element={<Home />} />

              <Route path="corsi" element={<Corsi />} />
              <Route path="tornei" element={<Tornei />} />
              <Route path="scherma" element={<Corsi />} />

              <Route path="ricostruzione" element={<Ricostruzione />} />
              <Route path="rievocazione" element={<Ricostruzione />} />
              <Route path="rievocazioni" element={<Ricostruzione />} />
              <Route
                path="cangrande-i-della-scala"
                element={<Ricostruzione />}
              />
              <Route path="tag/scaligeri" element={<Ricostruzione />} />

              <Route path="istruttori" element={<IstruttoriDetail />} />
              <Route path="medagliere" element={<Medagliere />} />
              <Route path="contatti" element={<ContattiDetail />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="privacy-policy" element={<Privacy />} />
              <Route path="cookies" element={<Cookie />} />

              <Route path="/pillole-di-storia" element={<History />} />
              <Route path="/pillole-di-storia/:slug" element={<History />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </main>

        <Footer />
        <BackToTop />
      </div>
    </BrowserRouter>
  );
}

export default App;
